import IAudioService from "../../spi/IAudioService";
import IAudioUser, { IAudioEvent } from "../../../types/IAudio";
import AgoraRTC from "agora-rtc-sdk";
//import inSoundFile from "../../../assets/media/in.mp3";
//import outSoundFile from "../../../assets/media/out.mp3";
import FirebaseService from "../firebase/FirebaseService";

const API_KEY: string = "005c6120d9a04872ba2d320a5fa17251";

export default class AgoraAudioService implements IAudioService {
    datasource?: any;
    private _client: any;
    private _localStream: any;
    private _remoteStreams: Array<any>;
    private firebase: FirebaseService;
    private static service: AgoraAudioService;

    private constructor() {
        this._remoteStreams = new Array<any>();
        this.firebase = FirebaseService.getInstance();
    }

    public static getInstance(): AgoraAudioService {
        if (this.service == null)
            this.service = new AgoraAudioService();
        return this.service;
    }

    getAudioStatus(): any {
        if(this._localStream){
            return {audioLevel: this._localStream.getAudioLevel()}
        } else {
            return {audioLevel: -1}
        }
    }

    async connectToRoom(channel: any, audioUId: number,
                    onDisconnect: (event: IAudioEvent) => void,
                    onSomeBodyJoined: (event: IAudioEvent) => void,
                    onSomeBodyLeft: (event: IAudioEvent) => void,
                    onSomeBodyMuted: (event: IAudioEvent) => void,
                    onSomeBodyUnmuted: (event: IAudioEvent) => void): Promise<any> {
        return new Promise(async (resolve, reject)=> {
            try {
                this._client = await AgoraRTC.createClient({ mode: "rtc", codec: "h264" });
                await this._client.init(API_KEY);
                this._subscribeToEvents(audioUId, onDisconnect, onSomeBodyJoined, onSomeBodyLeft, onSomeBodyMuted, onSomeBodyUnmuted);
                const result = await this.firebase.getAgoraToken(channel, audioUId);
                const token = result.data.token
                const uid = await this._client.join(token, channel, audioUId)
                this._localStream = AgoraRTC.createStream({
                    streamID: uid,
                    audio: true,
                    video: false,
                    screen: false,
                });
                // Initialize the local stream
                await this._localStream.init();
                await this._client.publish(this._localStream);
                // play stream with html element id "local_stream"
                this._localStream.play("local_stream");
                //this._client.enableAudioVolumeIndicator();
                resolve();
            } catch (e) {
                debugger;
                reject();
            }
        });
    }

    private _subscribeToEvents(audioUId: number, 
                                onDisconnect: (event: IAudioEvent) => void,
                                onSomeBodyJoined: (event: IAudioEvent) => void,
                                onSomeBodyLeft: (event: IAudioEvent) => void,
                                onSomeBodyMuted: (event: IAudioEvent) => void,
                                onSomeBodyUnmuted: (event: IAudioEvent) => void) {

        this._client.on("stream-added", (evt:any) => {
            const remoteStream = evt.stream;
            const id = remoteStream.getId();
            if (id !== audioUId) {
                this._client.subscribe(remoteStream, (err:any) => {
                    onSomeBodyJoined({
                        eventName: 'USER_JOINED',
                        uid: id
                    });
                });
            }
        });

        // Occurs when a user subscribes to a remote stream.
        this._client.on("stream-subscribed", (evt:any) => {
            const remoteStream = evt.stream;
            const id = remoteStream.getId();
            this._remoteStreams.push(remoteStream);
            this.addView(id);
            remoteStream.play("remote_stream_" + id, {});
        });

        // Occurs when the remote stream is removed; for example, a peer user calls Client.unpublish.
        this._client.on("stream-removed", (evt:any) => {
            const remoteStream = evt.stream;
            const id = remoteStream.getId();
            remoteStream.stop();
            this._remoteStreams = this._remoteStreams.filter((stream) => {
                return stream.getId() !== id;
            });
            this.removeView(id);
            onSomeBodyLeft({
                eventName: 'USER_LEFT',
                uid: id
            })
            
        });

        // Occurs when a per join.
        this._client.on("peer-online", (evt:any) => {
            let inSound = require('../../../assets/media/in.mp3');
            this._localStream.playEffect({ soundId: 1, filePath: inSound });
        });

        // Occurs when a peer leav
        this._client.on("peer-leave", (evt:any) => {
            let outSound = require('../../../assets/media/in.mp3');
            this._localStream.playEffect({ soundId: 2, filePath: outSound });
        });

        this._client.on("volume-indicator", function(evt:any){
            evt.attr.forEach(function(volume:any, index:number){
                    console.log(`${index} UID ${volume.uid} Level ${volume.level}`);
            });
        });

    }

    async disconnectFromRoom(params: any): Promise<any> {
        if(this._client){
            await this._client.leave();
            // close stream
            this._localStream.close();
            // stop stream
            this._localStream.stop();
            while (this._remoteStreams.length > 0) {
                const stream = this._remoteStreams.shift();
                const id = stream.getId();
                stream.stop();
                this.removeView(id);
            }
            this._localStream = null;
            this._remoteStreams = [];
            this._client = null;
            //this._published = false;
            //this._joined = false;
        }
    }

    mute(): Promise<any> {
        return new Promise((resolve, reject) => {
            try {
                //TODO: check local stream, if not valid reinitialize
                this._localStream.stop();
                this._localStream.muteAudio();
                resolve();
            } catch (e) {
                reject(e);
            }
        })
    }

    addView(id: string) {
        const slot: any = document.getElementById("remote_stream");
        const div = document.createElement("div");
        div.id = "remote_stream_" + id;
        slot.appendChild(div);
    }

    removeView(id: string) {
        let document: any = window.document;
        if (document.getElementById("remote_stream_" + id) != undefined) {
            document.getElementById("remote_stream")
                .removeChild(document.getElementById("remote_stream_" + id));
        }
    }

    unmute(): Promise<any> {
        return new Promise((resolve, reject) => {
            try {
                //TODO: check local stream, if not valid reinitialize
                this._localStream.unmuteAudio();
                resolve();
            } catch (e) {
                reject(e);
            }
        })
    }
}